export class Logger {
  info(message: string) {
    // Browser-safe logger for component bundle builds
    console.log(message);
  }

  error(message: string) {
    console.error(message);
  }
}
